
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import CouponList from './couponList.vue';
import PrimaryButton from '@/components/ui/primaryButton';

function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

export default {
  components: {
    PrimaryButton,
    CouponList,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    autoApply: {
      type: Boolean,
      default: false,
    },
    isCart: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      apply: this.$t('checkout.apply'),
      open: false,
      couponError: null,
      input: '',
    };
  },

  computed: {
    ...mapState([
      'order',
      'orderId',
      'usePoints',
      'patientId',
      'couponCode',
      'freeShippingCouponLeft',
    ]),
    ...mapGetters(['cartQuantity', 'orderQuantity', 'couponCodeApplied']),
    error() {
      return this.$t('checkout.coupon_' + this.couponError).replace(
        '{remaining}',
        this.freeShippingCouponLeft
      );
    },
  },

  watch: {
    orderQuantity: debounce(function (newValue, oldValue) {
      if (newValue > 0 && oldValue !== newValue) {
        if (
          this.order &&
          this.orderId &&
          this.autoApply &&
          this.couponCode &&
          !this.couponCodeApplied
        ) {
          this.$nextTick(() => {
            this.applyCoupon(this.couponCode);
          });
        }
      }
    }, 100),
  },

  methods: {
    ...mapMutations([
      'setOrder',
      'setCouponCode',
      'setFreeShippingCouponLimit',
      'setFreeShippingCouponLeft',
      'clearCoupon',
    ]),
    ...mapActions(['togglePoints']),

    resetError() {
      this.couponError = null;
    },

    toggle() {
      if (!this.disabled) {
        this.open = !this.open;
      }
    },

    applyCoupon(coupon) {
      this.$bolev
        .coupon({
          coupon,
          orderId: this.orderId,
          patientId: this.patientId,
        })
        .then((res) => {
          if (res.data.error) {
            this.couponError = coupon === this.couponCode ? '' : res.data.error;
            if (res.data.details) {
              this.setFreeShippingCouponLeft(
                res.data.details.remaining.toFixed(2) ?? undefined
              );
              this.setFreeShippingCouponLimit(
                res.data.details.minimum.toFixed(2) ?? undefined
              );
            }
          } else if (res.data.order) {
            // TODO: Is message being used?
            this.message = null;
            this.couponError = null;
            if (!this.usePoints) {
              this.setOrder(res.data.order);
            } else {
              this.togglePoints(false);
            }
          }
        })
        .catch(() => {
          // TODO: Is message being used?
          this.message = this.$t('global.error');
        });
    },
  },
};
